import React from 'react';
import ReactDOM from 'react-dom/client';
import LandingApp from './LandingApp';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LandingApp />
  </React.StrictMode>
);
